module.exports = __webpack_public_path__ + "static/img/1.7b78e65.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/eng/1.png
// module id = ySSU
// module chunks = 0